import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'pv-fuel-icon-column',
    templateUrl: './fuel-icon-column.component.html',
    styleUrls: ['./fuel-icon-column.component.scss'],
    standalone: false
})
export class FuelIconColumnComponent implements OnInit {
  @Input() rowData: any;
  value: string | number;

  constructor() { }

  ngOnInit(): void {
  }

}
